import { useI18nContext } from "@hopper-b2b/i18n";

export const useCountryCode = () => {
  const { brand } = useI18nContext();
  return brand.preferredCountryCode || "SG";
};
